export const dxAdvisoryData = {
  // In-page navigation anchors
  navItems: [
    { label: "DX顧問とは", anchor: "#about" },
    { label: "支援内容", anchor: "#monthly-service" },
    { label: "毎月の進め方", anchor: "#monthly-cycle" },
    { label: "対応範囲", anchor: "#scope" },
    { label: "料金", anchor: "#pricing" },
    { label: "よくある質問", anchor: "#faq" },
  ],

  // Section 1: Compact Hero
  hero: {
    breadcrumbs: [
      { label: "ホーム", href: "/" },
      { label: "サービス", href: null },
      { label: "DX顧問", href: null },
    ],
    serviceLabel: "SERVICE 01",
    serviceSubLabel: "DX ADVISORY",
    mainCopy: "社内にDX担当者がいなくても、\nデジタル活用を止めないために。",
    description:
      "中小企業・小規模事業者の社外DX担当として、業務課題の整理から、AI・ITツールの選定、導入、運用の定着まで継続して支援します。",
    tags: [
      { label: "中小企業・小規模事業者向け", icon: "ri-building-2-line" },
      { label: "月額制", icon: "ri-calendar-check-line" },
      { label: "訪問・オンライン対応", icon: "ri-global-line" },
      { label: "AI・ウェブ・業務改善を横断支援", icon: "ri-stack-line" },
    ],
    image:
      "https://readdy.ai/api/search-image?query=Warm%20abstract%20organic%20background%20with%20flowing%20soft%20shapes%20in%20cream%20and%20light%20beige%20tones%2C%20subtle%20paper%20texture%20feel%2C%20minimal%20artistic%20composition%2C%20warm%20orange%20accents%2C%20no%20people%20no%20text%20no%20objects%2C%20editorial%20abstract%20art%20suitable%20for%20hero%20section%20background%2C%20gentle%20curves%2C%20warm%20neutral%20palette%2C%20Japanese%20design%20sensibility&width=1920&height=1080&seq=dx-advisory-hero-bg&orientation=landscape",
  },

  // Section 3: Service Overview (new)
  serviceOverview: {
    label: "SERVICE OVERVIEW",
    title: "DX顧問 サービス概要",
    description:
      "このページを最後まで読まなくても、DX顧問の基本的な仕組みがわかります。",
    items: [
      { label: "対象", value: "社内にIT・DX担当者がいない中小企業・小規模事業者" },
      { label: "契約形態", value: "月額顧問契約" },
      { label: "支援方法", value: "月次定例ミーティング＋契約範囲内での随時相談" },
      { label: "対応領域", value: "AI活用、業務改善、ウェブ、Google環境、ITツール" },
      { label: "訪問対応", value: "都内近郊を中心に対応" },
      { label: "制作・開発", value: "必要に応じて別途お見積り" },
    ],
  },

  // Section 4: Challenges (compact)
  challenges: {
    label: "CHALLENGES",
    title: "デジタルの課題を、経営者や一人の担当者だけで抱えていませんか。",
    items: [
      {
        icon: "ri-lightbulb-line",
        title: "AIを使いたいが何から始めればよいか分からない",
        desc: "生成AIの情報は増えているが、自社のどの業務に使えるのか判断できない。",
      },
      {
        icon: "ri-user-search-line",
        title: "ITについて相談できる担当者が社内にいない",
        desc: "システム会社や制作会社へ相談する前に、課題を整理してくれる相手がいない。",
      },
      {
        icon: "ri-tools-line",
        title: "導入したツールが定着しない",
        desc: "新しいサービスを契約しても、運用方法が決まらず、結局使われなくなる。",
      },
      {
        icon: "ri-user-shared-line",
        title: "業務が特定の人に集中している",
        desc: "担当者しか分からない仕事が多く、休みや退職によって業務が止まる不安がある。",
      },
      {
        icon: "ri-puzzle-line",
        title: "ウェブやGoogle環境が整理されていない",
        desc: "ホームページ、Google Drive、メール、生成AI、各種システムを別々の会社へ相談している。",
      },
      {
        icon: "ri-question-line",
        title: "システム会社へ何を依頼すべきか分からない",
        desc: "課題は感じているが、どのようなツールや仕組みが必要なのかを言語化できない。",
      },
    ],
  },

  // Section 5: About DX Advisory (definition first, comparison secondary)
  about: {
    label: "ABOUT DX ADVISORY",
    title: "改善を毎月前へ進める、社外のDX担当者",
    description:
      "DX顧問は、質問があったときだけ回答するサービスではありません。現在の業務と課題を継続的に把握し、優先順位を整理し、実行できる改善を一つずつ進めます。",
    description2:
      "大規模なシステム導入を前提にせず、現在の人員、予算、利用環境に合わせて、小さな改善から始めます。",
    spotConsulting: {
      title: "スポットのIT相談",
      points: [
        "発生した問題や質問に対応する",
        "案件ごとに必要な支援を依頼する",
        "導入や制作単位で契約する",
      ],
    },
    nobleDx: {
      title: "ノーブルラボのDX顧問",
      points: [
        "業務課題を継続的に把握する",
        "優先順位と改善計画を整理する",
        "導入後の活用状況も確認する",
        "AI、ウェブ、ITツールを横断して相談できる",
      ],
    },
  },

  // Section 6: Monthly Service (most important + includes deliverables + mid CTA)
  monthlyService: {
    label: "SERVICE",
    title: "月額料金内で、課題整理から定着確認までを支援",
    centerLabel: "毎月の改善",
    items: [
      {
        num: "01",
        title: "月次ミーティング",
        desc: "毎月1回、現在の課題と次に取り組む内容を確認します。",
        icon: "ri-calendar-check-line",
      },
      {
        num: "02",
        title: "DX・AI・ウェブの随時相談",
        desc: "生成AI、Google Workspace、ウェブ、業務ツールについて契約範囲内で相談できます。",
        icon: "ri-chat-3-line",
      },
      {
        num: "03",
        title: "業務課題の整理",
        desc: "困りごとをツールに置き換える前に、業務の流れと原因を整理します。",
        icon: "ri-file-list-3-line",
      },
      {
        num: "04",
        title: "改善施策の提案",
        desc: "現在の予算や人員に合わせて、実行しやすい改善方法を提案します。",
        icon: "ri-lightbulb-flash-line",
      },
      {
        num: "05",
        title: "ツール選定・導入支援",
        desc: "AIサービス、Google Workspace、クラウドツールの比較・選定・初期設定を支援します。",
        icon: "ri-computer-line",
      },
      {
        num: "06",
        title: "導入後の定着確認",
        desc: "導入した仕組みが実際に使われているかを確認し、必要に応じて運用を修正します。",
        icon: "ri-check-double-line",
      },
    ],
    cyclePhases: ["整理", "実行", "定着", "次の改善"],

    // Integrated deliverables (from old separate section)
    deliverables: {
      title: "打ち合わせだけで終わらず、改善の記録を残します。",
      items: [
        { icon: "ri-file-text-line", text: "月次ミーティング記録" },
        { icon: "ri-clipboard-line", text: "DX課題一覧" },
        { icon: "ri-stack-line", text: "改善施策の優先順位" },
        { icon: "ri-arrow-right-circle-line", text: "次回までのアクション" },
        { icon: "ri-settings-3-line", text: "導入ツールと運用ルールの記録" },
        { icon: "ri-book-open-line", text: "必要に応じた手順書やテンプレート" },
      ],
    },

    // Mid CTA
    midCta: {
      text: "自社の場合、どこまで相談できるか確認してみませんか。",
      button: "DX顧問について相談する",
    },
  },

  // Section 7: Monthly Cycle
  monthlyCycle: {
    label: "MONTHLY CYCLE",
    title: "相談では終わらず、PDCAを回す",
    centerText: "一歩ずつ前へ。",
    steps: [
      {
        num: "01",
        title: "状況を確認する",
        desc: "現在の困りごと、業務の変化、前回の施策の状況を確認します。",
      },
      {
        num: "02",
        title: "優先順位を決める",
        desc: "効果と緊急度を見ながら、次に取り組む課題を決めます。",
      },
      {
        num: "03",
        title: "小さく実行する",
        desc: "設定変更、テンプレート作成、AI活用、業務フロー整理などを実施します。",
      },
      {
        num: "04",
        title: "定着状況を確認する",
        desc: "実際の運用状況を確認し、必要に応じて改善します。",
      },
    ],
  },

  // Section 8: First 3 Months (simplified)
  firstThreeMonths: {
    label: "FIRST 3 MONTHS",
    title: "最初の3か月で、課題と改善の進め方を見える化",
    note: "支援内容は、企業ごとの課題や利用環境に合わせて調整します。",
    months: [
      {
        month: "1か月目",
        purpose: "現在の課題と優先順位を明確にする",
        deliverables: "DX課題一覧・優先順位表",
        tasks: "業務内容と利用ツールの確認、困りごとのヒアリング、優先課題の整理、改善テーマの決定",
      },
      {
        month: "2か月目",
        purpose: "実行しやすい改善から着手する",
        deliverables: "テンプレート・運用ルール・設定内容",
        tasks: "生成AIの利用開始、ファイル共有方法の整理、業務テンプレートの作成、利用ルールの整備",
      },
      {
        month: "3か月目",
        purpose: "利用状況を確認し、次のテーマを決める",
        deliverables: "振り返り・次の改善計画",
        tasks: "利用状況の確認、課題や使いにくさの修正、次の改善テーマの選定、継続支援計画の作成",
      },
    ],
  },

  // Section 9: Scope (important)
  scope: {
    label: "SCOPE",
    title: "相談・助言は月額料金内。制作・開発は、別途ご提案",
    note: "別途費用が必要な場合は、作業を開始する前に内容と費用をご説明します。",
    included: {
      title: "月額顧問料に含まれるもの",
      items: [
        "月次ミーティング",
        "DX・AI・ウェブに関する相談",
        "課題整理と改善提案",
        "ツール選定の助言",
        "軽微な設定や操作支援",
        "運用状況の確認",
        "外部業者の提案内容に関する助言",
        "月次記録と次のアクション整理",
      ],
    },
    excluded: {
      title: "原則として別途費用になるもの",
      items: [
        "ホームページ制作・大規模改修",
        "業務システムやツールの開発",
        "大量のデータ入力や事務代行",
        "長時間の現地作業",
        "パソコンやネットワーク機器の修理",
        "有料サービスやライセンスの利用料",
        "撮影、取材、原稿作成",
        "法律、税務、労務など専門資格が必要な判断",
      ],
    },
  },

  // Section 10: Pricing (important, DX顧問 as hero)
  pricing: {
    label: "PRICE",
    title: "課題や支援範囲に合わせた月額制",
    plans: [
      {
        name: "DX顧問",
        pricing: "月額 50,000円〜",
        pricingDetail: "会社全体の業務改善、AI・IT・ウェブ活用、改善の優先順位整理。",
        features: [
          "月1回の定例ミーティング",
          "契約範囲内での随時相談",
          "業務課題と優先順位の整理",
          "改善施策の提案",
          "ツール選定に関する助言",
          "次回までのアクション整理",
        ],
        icon: "ri-user-star-line",
        isMain: true,
        note: "訪問頻度、相談範囲、設定や実作業の量に応じて料金が変わります。",
      },
      {
        name: "初期整理・導入支援",
        pricing: "100,000円〜",
        features: [
          "業務と課題のヒアリング",
          "利用中のツールやデータの確認",
          "課題一覧と優先順位の整理",
          "Google Workspaceや生成AIの初期設定",
          "AI利用ルールの作成",
          "テンプレートや簡易手順書の作成",
          "操作説明・研修",
        ],
        icon: "ri-rocket-line",
        isMain: false,
        note: "設定するサービス、対象人数、データ整理、研修などの範囲によって費用が変わります。",
      },
      {
        name: "制作・システム開発",
        pricing: "個別見積",
        features: [
          "ホームページ制作・改修",
          "申込フォーム",
          "施設予約システム",
          "会員管理ツール",
          "FAQ・チャットボット",
          "業務自動化",
        ],
        icon: "ri-code-s-slash-line",
        isMain: false,
        note: "顧問契約では、必要性の整理や仕様の検討を支援します。実際の制作・開発作業は原則として別途お見積りします。",
      },
    ],
  },

  // Section 11: Examples (compact, moved later)
  examples: {
    label: "EXAMPLES",
    title: "このようなご相談に対応します。",
    items: [
      "社内で生成AIを使うルールをつくりたい",
      "Google Driveのファイルを整理したい",
      "システム会社から提出された提案を一緒に確認してほしい",
      "ホームページと問い合わせ対応をまとめて改善したい",
      "紙やメールで行っている申込業務を整理したい",
      "社員へAIの使い方を説明してほしい",
    ],
  },

  // Section 12: Who It Is For (compact)
  whoItIsFor: {
    label: "WHO IT IS FOR",
    title: "サービスの相性",
    suitable: {
      title: "DX顧問が向いている企業",
      items: [
        "社内に専任のDX担当者がいない",
        "小さな改善を継続して進めたい",
        "導入後の運用まで相談したい",
        "複数の業者をまとめる相談相手がほしい",
      ],
    },
    unsuitable: {
      title: "別の支援方法が適している可能性がある企業",
      items: [
        "大規模な基幹システム開発のみを依頼したい",
        "決められた作業をすべて代行してほしい",
        "社内に大規模なDX専門部署がある",
      ],
    },
  },

  // Section 13: FAQ
  faq: {
    label: "FAQ",
    title: "よくある質問",
    items: [
      {
        q: "DXについて何も決まっていなくても相談できますか",
        a: "はい。ツールや導入内容が決まっていない段階から、現在の状況と困りごとを整理します。",
      },
      {
        q: "毎月、必ずシステムを導入するのですか",
        a: "いいえ。業務の整理や運用ルールの見直しだけで改善できる場合もあります。必要性を確認したうえで提案します。",
      },
      {
        q: "チャットやメールで相談できますか",
        a: "契約内容に応じて対応します。緊急対応や相談回数については、契約時に範囲を定めます。",
      },
      {
        q: "訪問対応は可能ですか",
        a: "都内近郊を中心に対応します。訪問回数や地域によって、交通費や追加費用が発生する場合があります。",
      },
      {
        q: "ホームページの相談もできますか",
        a: "はい。株式会社ノーブルウェブのウェブ制作事業部と連携し、制作、改修、保守についても相談できます。",
      },
      {
        q: "システム開発は月額料金に含まれますか",
        a: "開発作業は原則として別途見積です。顧問契約では、必要性の整理、仕様の検討、進め方の助言を行います。",
      },
      {
        q: "契約期間はありますか",
        a: "現在、正式な契約条件を整備中です。詳細が決まり次第、お問い合わせいただいた方へご案内します。",
      },
    ],
  },

  // Section 14: Related Services (new)
  relatedServices: {
    label: "RELATED SERVICES",
    title: "現況に応じて、適切な支援方法をご案内します",
    items: [
      {
        title: "伴走型AI事務局サポート",
        desc: "商店街、社団法人、NPO、同窓会、会員組織など、少人数の事務局運営を支援します。",
        href: null,
        icon: "ri-team-line",
      },
      {
        title: "AI・デジタル導入支援",
        desc: "生成AIやGoogle Workspaceなどの初期導入、ルールづくり、研修を支援します。",
        href: "/service/ai-digital",
        icon: "ri-robot-line",
      },
      {
        title: "業務ツール・システム開発",
        desc: "申込、予約、会員管理、チャットボットなど、業務に必要な小規模システムを開発します。",
        href: "/service/business-tool",
        icon: "ri-terminal-box-line",
      },
    ],
  },

  // Section 15: CTA
  cta: {
    label: "CONTACT",
    heading: "DXについて、何から始めるべきか一緒に考えませんか",
    description:
      "具体的なツールやシステムが決まっていなくても問題ありません。現在の業務や困りごとを伺い、優先して取り組むべきことから整理します。",
    note: "無理なシステム導入や契約を前提としたご提案は行いません。",
    beforeFormPoints: [
      "何も決まっていない段階でも相談可能",
      "オンライン・訪問対応",
      "無理なシステム導入を前提にしない",
    ],
    inquiryTypes: [
      "DX顧問について",
      "伴走型AI事務局サポートについて",
      "AI・デジタル導入について",
      "業務ツール・システム開発について",
      "セミナー・講演について",
      "提携・紹介について",
      "その他",
    ],
  },
};